import {MyCalendarType} from "./type";
import {SET_CALENDAR} from "./const";
import { MyCalendarActionTypes } from "./actions";

const INITIAL_STATE: MyCalendarType = {
    calendar: [],
    collabs: [],
    patrimonies: [],
    serviceDeliveryTypes: [],
    weekTemplateId: ''
};

export const MyCalendarReducer = (state: MyCalendarType = INITIAL_STATE, action: MyCalendarActionTypes) => {
    switch (action.type) {
        case SET_CALENDAR:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};
